export const habaAddressBook = {
  habaAddressBook : {
    isDefaultDeliveryAddress: 'Default deliveryaddress',
    isBillingAddress:'Is billingaddress',
    headline : 'Address book',
    addNewAddress: 'Add new address',
    updateAddress: 'Update address',
    deleteAddress: 'Delete address',
    phoneLabel: 'Phone:',
    msg : {
      updateAddress : 'Select address'
    },
    subHeadline: 'add new address'
  }
};
